export default {
    'name': 'dot',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<circle cx=\'12\' cy=\'12\' r=\'3\' fill=\'#FF4171\'/>'
}
